import React from 'react'

import Container from '../structure/Container'
import { COLORS } from '@btime/constants'

const styles = {
  root: {
    backgroundColor: COLORS.light3,
    padding: '3rem',
    position: 'relative'
  },

  content: {
    backgroundColor: COLORS.white,
    padding: '1cm',
    borderRadius: '5px',
    minHeight: '29.7cm',
    overflow: 'hidden'
  }
}

const Preview = ({ children, orientation = 'portrait', allowOverflow = false }) => {
  const maxWidth = orientation === 'portrait' ? '21cm' : '29.7cm'
  const minHeight = orientation === 'portrait' ? '29.7cm' : '21cm'
  const contentStyle = {
    ...styles.content,
    minHeight,
    ...(allowOverflow ? { overflow: 'visible', width: 'max-content' } : {})
  }
  return (
    <div style={styles.root}>
      <Container maxWidth={maxWidth}>
        <div style={contentStyle}>{children}</div>
      </Container>
    </div>
  )
}

export default Preview
